import { render, staticRenderFns } from "./EmprestimoList.vue?vue&type=template&id=b41f1f38"
import script from "./EmprestimoList.vue?vue&type=script&lang=js"
export * from "./EmprestimoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports